import React from "react";
import { AlarmClock, Ban, CalendarDays, RotateCcw } from "lucide-react";
import { useTranslation } from "react-i18next";
import { OverrideMode } from "./OccurrenceOverrideDialog";

interface OccurrenceActionsMenuProps {
  isCancelled: boolean;
  hasOverride: boolean;
  onOverride: (mode: OverrideMode) => void;
  onRestore: () => void;
}

const itemClass =
  "flex w-full items-center gap-2 rounded-lg px-3 py-1.5 text-left text-sm text-grey-10 hover:bg-grey-95 dark:text-grey-90 dark:hover:bg-primary-20";

/** The dropdown of per-date overrides for one occurrence row. */
const OccurrenceActionsMenu: React.FC<OccurrenceActionsMenuProps> = ({
  isCancelled,
  hasOverride,
  onOverride,
  onRestore,
}) => {
  const { t } = useTranslation();

  return (
    <div className="absolute right-0 top-8 z-20 w-44 rounded-xl border border-grey-90 bg-white p-1 shadow-lg dark:border-primary-20 dark:bg-primary-10">
      {!isCancelled && (
        <>
          <button type="button" className={itemClass} onClick={() => onOverride("reschedule")}>
            <CalendarDays size={14} />
            <span>{t("sessions.occurrenceList.reschedule")}</span>
          </button>
          <button type="button" className={itemClass} onClick={() => onOverride("retime")}>
            <AlarmClock size={14} />
            <span>{t("sessions.occurrenceList.retime")}</span>
          </button>
          <button
            type="button"
            className="flex w-full items-center gap-2 rounded-lg px-3 py-1.5 text-left text-sm text-red-600 hover:bg-red-100 dark:text-red-400 dark:hover:bg-red-900/30"
            onClick={() => onOverride("cancel")}
          >
            <Ban size={14} />
            <span>{t("sessions.occurrenceList.cancel")}</span>
          </button>
        </>
      )}
      {hasOverride && (
        <button type="button" className={itemClass} onClick={onRestore}>
          <RotateCcw size={14} />
          <span>{t("sessions.occurrenceList.restore")}</span>
        </button>
      )}
    </div>
  );
};

export default OccurrenceActionsMenu;
